module.exports = __webpack_public_path__ + "72489973c756501f9eac8ee493040c79.pdf";